import { shopOriginFor } from './api-origin.js';

/**
 * The store's web shop, for the POS to link to (decision 157).
 *
 * Derived from this page's own hostname, like the API's origin, so one bundle
 * serves every store and staging links to staging's shop. Guarded for the unit
 * suite, which imports screens where there is no `window`.
 */
export const SHOP_ORIGIN = shopOriginFor(
  typeof window === 'undefined' ? '' : window.location.hostname,
  import.meta.env.VITE_SHOP_URL,
);

/** A style's page on the shop, by the address it was given when published. */
export function shopPageFor(webSlug: string): string {
  return `${SHOP_ORIGIN}/p/${encodeURIComponent(webSlug)}`;
}
